import { useCallback } from "react";

interface MountClassesProps {
  nodeId: string;
}

type MountClassesReturn = {
  handleRemoveClass: () => void;
}

type MountClassesHookType = (props: MountClassesProps) => MountClassesReturn

export const useMountClasses: MountClassesHookType = (props) => {
  const { nodeId } = props;

  const handleRemoveClass = useCallback(() => {
    const nodeContainer = document.getElementById(nodeId)

    if (nodeContainer) {
      nodeContainer.className = "";
    }
  }, [nodeId])

  return {
    handleRemoveClass,
  }
}